<template>
  <b-row>
    <b-col md="8">
      <b-form inline @submit.prevent="startSearch">
        <b-form-input v-model="searchString" placeholder="Search" class="mx-1"></b-form-input>
        <b-form-select v-model="typeFilterVal" :options="typeFilterOptions" title="Filter by type"
          class="mx-1"></b-form-select>
        <b-form-select v-model="tagFilterVal" :options="tagFilterOptions" title="Filter by RRP POS Type"
          class="mx-1"></b-form-select>
        <b-form-select v-model="tierFilterVal" :options="tierFilterOptions" title="Filter by tier"
          class="mx-1"></b-form-select>
        <b-form-select v-model="channelFilterVal" :options="channelFilterOptions" title="Filter by channel split"
          class="mx-1"></b-form-select>
        <b-form-select v-model="orientationFilterVal" :options="orientationFilterOptions" title="Filter by orientation"
          class="mx-1"></b-form-select>
        <b-form-select v-model="positionFilterVal" :options="positionFilterOptions" title="Filter by position"
          class="mx-1"></b-form-select>
        <b-form-select v-model="printFilterVal" :options="printFilterOptions" title="Filter by print"
          class="mx-1"></b-form-select>
        <b-form-checkbox v-model="unassignedDevicesFilterVal" class="mx-1">
          No group
        </b-form-checkbox>
        <b-button @click="startSearch" variant="primary" class="m-1">Search</b-button>
        <b-button @click="clearSearch" variant="danger" class="m-1">Clear Search</b-button>
      </b-form>
    </b-col>
    <b-col md="4" v-if="totalItems > 0">
      <b-pagination v-model="currentPage" :per-page="itemsPerPage" :limit="5" :total-rows="totalItems"
        @change="pageChanged" :disabled="dataLoading" align="fill" class="mt-1">
      </b-pagination>
    </b-col>
  </b-row>
</template>

<script>
import axios from '@/modules/axiosInterceptor';
import { apiUrlPrefix } from '@/modules/staticData';
import { DeviceAttrService } from '@/services/deviceAttrService';
import { restoreFilters, storeFilters } from './filterstorage';

let intervalRef = null;

export default {
  data() {
    const filters = restoreFilters('devices');
    return {
      apiUrl: 'devices',
      currentPage: filters?.currentPage ?? 1,
      itemsPerPage: 10,
      totalItems: -1,
      items: [],
      // filters
      searchString: filters?.searchString ?? '',
      fixedSearchString: filters?.fixedSearchString ?? '',
      typeFilterVal: filters?.typeFilterVal ?? null,
      fixedTypeFilterVal: filters?.fixedTypeFilterVal ?? null,
      tagFilterOptions: filters?.tagFilterOptions ?? [],
      tagFilterVal: filters?.tagFilterVal ?? null,
      fixedTagFilterVal: filters?.fixedTagFilterVal ?? null,
      tierFilterOptions: filters?.tierFilterOptions ?? [],
      tierFilterVal: filters?.tierFilterVal ?? null,
      fixedTierFilterVal: filters?.fixedTierFilterVal ?? null,
      channelFilterOptions: filters?.channelFilterOptions ?? [],
      channelFilterVal: filters?.channelFilterVal ?? null,
      fixedChannelFilterVal: filters?.fixedChannelFilterVal ?? null,
      orientationFilterVal: filters?.orientationFilterVal ?? null,
      orientationFixedFilterVal: filters?.orientationFixedFilterVal ?? null,
      positionFilterVal: filters?.positionFilterVal ?? null,
      positionFixedFilterVal: filters?.positionFixedFilterVal ?? null,
      printFilterVal: filters?.printFilterVal ?? null,
      printFixedFilterVal: filters?.printFixedFilterVal ?? null,
      unassignedDevicesFilterVal: filters?.unassignedDevicesFilterVal ?? false,
      fixedUnassignedDevicesFilterVal: filters?.fixedUnassignedDevicesFilterVal ?? false,
      // other options
      typeFilterOptions: [
        { value: null, text: 'Type' },
        { value: 0, text: 'Android' },
        { value: 1, text: 'WEB' },
      ],
      orientationFilterOptions: [
        { value: null, text: 'Orientation' },
        { value: 0, text: 'Landscape' },
        { value: 1, text: 'Portrait' },
      ],
      positionFilterOptions: [
        { value: null, text: 'Position' },
        { value: 'Single', text: 'Single' },
        { value: 'Left', text: 'Left' },
        { value: 'Right', text: 'Right' },
        { value: 'Middle/Back', text: 'Middle/Back' },
      ],
      printFilterOptions: [
        { value: null, text: 'Print' },
        { value: 0, text: 'No' },
        { value: 1, text: 'Yes' },
      ],
      dataLoading: false,
      filters: [],
    };
  },
  props: {
    perPage: {
      type: [Number],
      required: false,
    },
    queryStructure: {
      type: [Object],
      required: true,
    },
    pollingInterval: {
      type: [Number],
      required: false,
      default: 0,
    },

  },
  async created() {
    const { tags, tiers, channels } = await DeviceAttrService.getAllAttrs(false);
    this.tagFilterOptions = [{ value: null, text: 'RRP POS Type' }, ...tags];
    this.tierFilterOptions = [{ value: null, text: 'Tier' }, ...tiers];
    this.channelFilterOptions = [{ value: null, text: 'Channel split' }, ...channels];
    if (this.perPage) {
      this.itemsPerPage = this.perPage;
    }
    this.pageChanged();
  },
  beforeDestroy() {
    this.savePagination();
    this.resetPollingInterval();
  },
  methods: {
    // fetches the data retuns the promise
    fetchData(newPage) {
      // generate params
      const params = {
        [this.queryStructure.pagePropName]: newPage,
        [this.queryStructure.perPagePropName]: this.itemsPerPage,
        [this.queryStructure.searchPropName]: this.fixedSearchString,
        [this.queryStructure.typeFilterPropName]: this.fixedTypeFilterVal,
        [this.queryStructure.tagFilterPropName]: this.fixedTagFilterVal,
        [this.queryStructure.tierFilterPropName]: this.fixedTierFilterVal,
        [this.queryStructure.channelFilterPropName]: this.fixedChannelFilterVal,
        [this.queryStructure.orientationFilterPropName]: this.orientationFixedFilterVal,
        [this.queryStructure.positionFilterPropName]: this.positionFixedFilterVal,
        [this.queryStructure.printFilterPropName]: this.printFixedFilterVal,
        [this.queryStructure.unassignedDevicesFilterPropName]: this.fixedUnassignedDevicesFilterVal,
      };
      // remove false unassigned devices filter
      if (params[this.queryStructure.unassignedDevicesFilterPropName] === false) {
        delete params[this.queryStructure.unassignedDevicesFilterPropName];
      }
      // custom keys and values
      if (this.queryStructure.custom && Object.keys(this.queryStructure).length > 0) {
        Object.keys(this.queryStructure.custom).forEach((k) => {
          params[k] = this.queryStructure.custom[k];
        });
      }
      // nuke empty strings, null and undefined values
      Object.keys(params).forEach((k) => {
        if (
          [null, undefined].includes(params[k])
          || (typeof params[k] === 'string' && params[k].trim().length === 0)
        ) {
          delete params[k];
        }
      });
      this.filters = params;
      // fetch the data
      const deferred = new Promise((resolve, reject) => {
        const axiosPromise = axios.get(apiUrlPrefix + this.apiUrl, { params });
        axiosPromise.then((r) => { resolve(r.data); });
        axiosPromise.catch(() => { reject(); });
      });
      return deferred;
    },
    // updates the data
    pageChanged(np) {
      if (np) this.currentPage = np;
      const newPage = np || this.currentPage;
      this.dataLoading = true;
      this.$emit('items-updated', null);
      this.resetPollingInterval();
      this.fetchData(newPage).then((data) => {
        const responseData = data[this.queryStructure.responseDataKey];
        this.items = responseData.data;
        this.totalItems = responseData.total;
        this.setPollingInterval();
        // check edge case when last item on last page and cover an edge case when there's 0 items
        const maxPage = Math.ceil(this.totalItems / this.itemsPerPage) || 1;
        if (maxPage < this.currentPage) {
          this.currentPage = maxPage;
          this.pageChanged();
        }
        this.savePagination();
        this.$emit('items-updated', this.items);
      }, () => {
      }).finally(() => {
        this.dataLoading = false;
      });
    },
    startSearch() {
      this.fixedSearchString = this.searchString;
      this.fixedTypeFilterVal = this.typeFilterVal;
      this.fixedTagFilterVal = this.tagFilterVal;
      this.fixedTierFilterVal = this.tierFilterVal;
      this.fixedChannelFilterVal = this.channelFilterVal;
      this.orientationFixedFilterVal = this.orientationFilterVal;
      this.positionFixedFilterVal = this.positionFilterVal;
      this.printFixedFilterVal = this.printFilterVal;
      this.fixedUnassignedDevicesFilterVal = this.unassignedDevicesFilterVal;
      this.currentPage = 1;
      this.pageChanged();
    },
    clearSearch() {
      this.fixedSearchString = '';
      this.searchString = '';
      this.fixedTypeFilterVal = null;
      this.fixedTagFilterVal = null;
      this.fixedTierFilterVal = null;
      this.fixedChannelFilterVal = null;
      this.orientationFixedFilterVal = null;
      this.positionFixedFilterVal = null;
      this.printFixedFilterVal = null;
      this.fixedUnassignedDevicesFilterVal = false;
      this.typeFilterVal = null;
      this.tagFilterVal = null;
      this.tierFilterVal = null;
      this.channelFilterVal = null;
      this.orientationFilterVal = null;
      this.positionFilterVal = null;
      this.unassignedDevicesFilterVal = false;
      this.currentPage = 1;
      this.pageChanged(1);
    },
    resetPollingInterval() {
      if (intervalRef) {
        window.clearInterval(intervalRef);
        intervalRef = null;
      }
    },
    setPollingInterval() {
      if (this.pollingInterval > 0) {
        intervalRef = window.setInterval(() => {
          this.pageChanged();
        }, this.pollingInterval * 1000);
      }
    },
    savePagination() {
      storeFilters('devices', {
        fixedSearchString: this.fixedSearchString,
        searchString: this.searchString,
        fixedTypeFilterVal: this.fixedTypeFilterVal,
        fixedTagFilterVal: this.fixedTagFilterVal,
        fixedTierFilterVal: this.fixedTierFilterVal,
        fixedChannelFilterVal: this.fixedChannelFilterVal,
        orientationFixedFilterVal: this.orientationFixedFilterVal,
        positionFixedFilterVal: this.positionFixedFilterVal,
        printFixedFilterVal: this.printFixedFilterVal,
        fixedUnassignedDevicesFilterVal: this.fixedUnassignedDevicesFilterVal,
        typeFilterVal: this.typeFilterVal,
        tagFilterVal: this.tagFilterVal,
        tierFilterVal: this.tierFilterVal,
        channelFilterVal: this.channelFilterVal,
        orientationFilterVal: this.orientationFilterVal,
        positionFilterVal: this.positionFilterVal,
        unassignedDevicesFilterVal: this.unassignedDevicesFilterVal,
        currentPage: this.currentPage,
      });
    }
  },
};
</script>
